<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" layout='inline'>
      <a-form-item label="手机号" name='phone'>
        <a-input v-model:value="search.phone" style='width:250px' placeholder="请输入手机号进行搜索" />
      </a-form-item>
      <a-form-item label="短信名称" name='name' v-show="open">
        <a-input v-model:value="search.name" style='width:250px' placeholder="请输入短信名称进行搜索" />
      </a-form-item>
      <a-form-item label="发送业务" name='send_business' v-show="open">
        <a-select v-model:value="search.send_business" :style="{width:'120px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">积分商城</a-select-option>
          <a-select-option :value="2">商户中心</a-select-option>
          <a-select-option :value="3">平台通知</a-select-option>
          <a-select-option :value="4">云店</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="短信类型" name='send_type' v-show="open">
        <a-select v-model:value="search.send_type" :style="{width:'120px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">通知类型</a-select-option>
          <a-select-option :value="2">营销类型</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="状态" name='status' v-show="open">
        <a-select v-model:value="search.status" :style="{width:'120px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="0">发送失败</a-select-option>
          <a-select-option :value="1">发送中</a-select-option>
          <a-select-option :value="2">发送成功</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="发送时间" name='time' v-show="open">
        <a-range-picker valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item @click='open = !open'>
        <a href="javascript:;" >{{open ? '收起':'展开'}}</a>
        <UpOutlined v-if='open' />
        <DownOutlined v-else />
      </a-form-item>
      <a-button type="primary" @click="searchTable">搜索</a-button>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref } from "vue";
  import { getSmsLog } from "@/api/message";
  import { DownOutlined, PlusOutlined, UpOutlined } from "@ant-design/icons-vue";
  const def = {
    limit: 10,
    page: 1,
    phone: "",
    send_type: '',
    send_business: "",
    name: "",
    status:""
  };
  export default {
    components: { DownOutlined, UpOutlined },
    name: "smsTemplate",
    setup() {
      const search = ref({ ...def });
      const data = ref([]);
      const listLoading = ref(false);
      const open = ref(false);
      let columns = [
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          width:120,
        },
        {
          title: "短信类型",
          dataIndex: "send_type",
          key: "send_type",
          width:120,
          customRender: ({ record }) => {
            return record.send_type == 1 ? '通知类型' : '营销类型'
          },
        },
        {
          title: "发送业务",
          dataIndex: "level_name",
          customRender: ({ record }) => {
            return record.send_business == 1 ? '积分商城' : record.send_business == 2 ? '商户中心' : record.send_business == 3 ? '平台通知' : '云店云店'
          },
          width:120,
        },
        {
          title: "短信名称",
          dataIndex: "name",
          key: "name",
          width:140,
        },
        {
          title: "发送内容",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "短信占用条数",
          dataIndex: "nums",
          key: "nums",
          width:120,
        },
        {
          title: "发送时间",
          dataIndex: "create_time",
          key: "create_time",
          width:120,
        },
        {
          title: "发送状态",
          width:120,
          customRender: ({ record }) => {
            return record.status == 1 ? '发送中' : record.status == 2 ? '发送成功' : '发送失败'
          },
        }
      ];
      // // 初始化 分页信息和筛选项信息
      let total = ref(0);
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 初始化数据
      const initData = async (values) => {
        listLoading.value = true
        let result = await getSmsLog(values)
          .then((res) => res.data)
          .catch((error) => error);
        listLoading.value = false
        data.value = result.data.data;
        total.value = result.data.total;

      };
      initData(search.value);
      const onChange = (e) => {
        search.value.start = e[0]
        search.value.end = e[1]
      }
      const searchTable = () => {
        search.value.page = 1
        initData(search.value)
      }
      return {
        search,
        columns,
        data,
        open,
        total,
        listLoading,
        onChange,
        searchTable,
        pageCurrentChange,
        pageSizeChange
      };
    },
  };
</script>